import SellerBadge from 'domains/seller/atoms/seller-badge'
import TimeUtil from 'utils/time-util'
import ConsignmentInboundRequestStatusBadge from 'domains/consignment-inbound-request/status-badge/consignment-inbound-request-status-badge'
import ConsignmentInboundRequestShippingMethodBadge from 'domains/consignment-inbound-request/shipping-method-badge/consignment-inbound-request-shipping-method-badge'

const ConsignmentInboundRequestTableCellService = {
  /**
   * Generate cell content for ConsignmentInboundRequestTable
   * @param {object} inboundRequest - Consignment::InboundRequest data
   */
  generateInboundCellData: (inboundRequest) => {
    const notes = inboundRequest.notes
    return {
      'code': {
        content: inboundRequest.code
      },
      'shipping_method': {
        content: <ConsignmentInboundRequestShippingMethodBadge shippingMethod={ inboundRequest.shipping_method } />
      },
      'dropoff_location_city': {
        content: inboundRequest.dropoff_location_city?.name ? inboundRequest.dropoff_location_city.name.toUpperCase() : '-'
      },
      'status': {
        content: <ConsignmentInboundRequestStatusBadge status={ inboundRequest.status } />
      },
      'quantity': {
        content: inboundRequest.quantity
      },
      'received_quantity': {
        content: inboundRequest.received_quantity
      },
      'received_at': {
        content: TimeUtil.format(inboundRequest.received_at)
      },
      'received_weight': {
        content: inboundRequest.received_weight && `${inboundRequest.received_weight} kg`
      },
      'scheduled_at': {
        content: TimeUtil.format(inboundRequest.scheduled_at)
      },
      'pickup_vehicle_type': {
        content: <span className='text-capitalize'>{ inboundRequest.pickup_vehicle_type }</span>
      },
      'seller_name': {
        content: inboundRequest.seller.name
      },
      'seller_code': {
        content: inboundRequest.seller.code
      },
      'seller_email': {
        content: inboundRequest.seller.email
      },
      'seller_phone': {
        content: inboundRequest.seller.mobile
      },
      'notes': {
        content : notes ? notes.note : '-',
        style   : {
          minWidth   : 400,
          whiteSpace : 'break-spaces'
        }
      },
      'seller_type': {
        content: <SellerBadge seller_type={ inboundRequest.seller.seller_type } />
      },
      'pickup_address': {
        style   : { whiteSpace: 'pre-wrap' },
        content : <>{ ConsignmentInboundRequestTableCellService.getPickupAddress(inboundRequest.pickup_address) }</>
      }
    }
  },

  getPickupAddress: (address) => {
    if (!address) return '-'
    return [
      address?.street_address,
      address?.sub_district,
      address?.district,
      address?.city,
      address?.province,
      address?.postal_code
    ].join('\n')
  }

}

export default ConsignmentInboundRequestTableCellService